import { useNavigate } from 'react-router-dom';
import { GraduationCap, Play, Clock, History } from 'lucide-react';

const MobileNavigation = () => {
  const navigate = useNavigate();

  return (
    <nav className="mobile-nav">
      <button className="mobile-nav-item active" onClick={() => navigate('/dashboard')} data-testid="mobile-nav-dashboard">
        <GraduationCap className="w-5 h-5" />
        <span className="text-xs">Home</span>
      </button>
      <button className="mobile-nav-item" onClick={() => navigate('/training')} data-testid="mobile-nav-training">
        <Play className="w-5 h-5" />
        <span className="text-xs">Train</span>
      </button>
      <button className="mobile-nav-item" onClick={() => navigate('/exam')} data-testid="mobile-nav-exam">
        <Clock className="w-5 h-5" />
        <span className="text-xs">Exam</span>
      </button>
      <button className="mobile-nav-item" onClick={() => navigate('/history')} data-testid="mobile-nav-history">
        <History className="w-5 h-5" />
        <span className="text-xs">History</span>
      </button>
    </nav>
  );
};

export default MobileNavigation;
